import transactionSession from '../instance';

const setTransactionState = (contextType, state) => {
  const { context } = transactionSession.get();

  if (contextType !== context) {
    throw new Error('Passed contextType does not match the context of the opened transaction');
  }

  transactionSession.setState(state);
};

export default setTransactionState;
